import type { Language } from '@application/types';
import type { LocationDescriptor } from 'history';
import type { ReactNode } from 'react';
import type { LogoType } from '..';

export type HeaderColor = 'light' | 'blue' | 'purple';

export interface HeaderLink {
  label: string;
  onClick?: () => void;
  link: LocationDescriptor;
  links?: HeaderLink[];
}

export type HeaderButtonStyle = 'default' | 'main';

export interface HeaderButton {
  label: string;
  onClick?: () => void;
  link?: LocationDescriptor;
  style?: HeaderButtonStyle;
  loading?: boolean;
}

export interface HeaderProps {
  color?: HeaderColor;
  links?: HeaderLink[];
  buttons?: HeaderButton[];
  onHomeClick?: () => void;
  languageLinks?: Record<Language, LocationDescriptor>;
  show?: boolean;
  canUseMobileNav?: boolean;
  logoType?: LogoType;
  unfinishedApplicationComponent: ReactNode;
  languageSelectorButtons: LanguageSelectorButton[];
  onStickyBlueBannerClick: () => void;
  onStoreNavbarClick: () => void;
  showStoreLink?: boolean;
  showStickyBlueBanner?: boolean;
}
export interface LanguageSelectorButton {
  label: string;
  onClick: () => void;
  selected: boolean;
  onDoubleClick?: () => void;
}
